// extracted by mini-css-extract-plugin
module.exports =  {"button":"_33974c2b58--button--wvpRY","dark":"_33974c2b58--dark--HdtBl"};